import { useRouter } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();

  router.afterEach((to, from) => {
    if (!to.path.includes('confirm-email')) {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 400);
    }
  });
});
